import {CanActivateFn, Router} from '@angular/router';
import {environment} from "../../environments/environment";
import {inject} from "@angular/core";

export const onlyLandingGuard: CanActivateFn = (route, state) => {

  const hasOnlyLandings = environment.isLandingsOnly;
  const router = inject(Router)


  if (hasOnlyLandings){
    return true;
  }
  //empty lp page on not slotvibe, 24slots or betrophy
  router.navigate(['not-found'])

  return false;
};
